import React from 'react';
import { WhirlpoolEntryData } from '../game/systems/WhirlpoolRenderer';

interface WhirlpoolTooltipProps {
  entry: WhirlpoolEntryData | null;
  isVisible: boolean;
}

const WHIRLPOOL_CLASS_COLORS: Record<string, string> = {
  C1: '#4fc3f7',
  C2: '#29b6f6',
  C3: '#7e57c2',
  C4: '#ab47bc',
  C5: '#ef5350',
  C6: '#d32f2f',
};

export const WhirlpoolTooltip: React.FC<WhirlpoolTooltipProps> = ({ entry, isVisible }) => {
  if (!isVisible || !entry) {
    return null;
  }

  // Calculate time remaining
  const timeRemaining = Math.max(0, entry.expiresAt - Date.now());
  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);

  // Mass usage
  const massPercent = Math.floor((entry.massUsed / entry.massLimit) * 100);

  const color = WHIRLPOOL_CLASS_COLORS[entry.class] || '#4fc3f7';

  return (
    <div
      style={{
        position: 'fixed',
        backgroundColor: '#0d1117',
        border: '1px solid #30363d',
        borderRadius: '4px',
        padding: '0',
        fontFamily: '"Sometype Mono", monospace',
        fontSize: '10px',
        color: '#c9d1d9',
        zIndex: 1000,
        minWidth: '180px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
      }}
    >
      {/* Title bar */}
      <div
        style={{
          backgroundColor: '#161b22',
          borderBottom: '1px solid #30363d',
          padding: '8px',
          fontWeight: 'bold',
          color: color,
          fontSize: '11px',
        }}
      >
        Whirlpool [{entry.class}]
      </div>

      {/* Content */}
      <div style={{ padding: '8px' }}>
        <div style={{ marginBottom: '4px' }}>Status: {entry.status.toUpperCase()}</div>
        <div style={{ marginBottom: '4px' }}>Mass: {massPercent}% used</div>
        <div style={{ marginBottom: '8px' }}>Time: {minutes}m {seconds}s</div>
        <div style={{ fontSize: '9px', color: '#8b949e', fontStyle: 'italic' }}>
          Click to enter
        </div>
      </div>
    </div>
  );
};
